const MASK_TOKEN_PATTERN = {
    '#': /[0-9]/,
    '_': /[a-z]|[A-Z]/,
    '?': /[a-z]|[A-Z]| |[A-zÀ-ú]/,
    '*': /[0-9]|[a-z]|[A-Z]/,
    '%': /./,
};

function updateMask(mask, el, event) {
    if (typeof mask === 'function')
        mask = mask();
    const value = el.value;

    if (event.detail && event.detail.repeat) {
        return true;
    }

    let newValue = '';
    el.value = '';
    let char, token;
    let valIdx = 0;

    for (let idx = 0; idx < mask.length; idx++) {
        if (valIdx >= value.length) {
            break;
        }

        char = value[valIdx];
        token = mask[idx];

        if (MASK_TOKEN_PATTERN[token]) {
            if (char.match(MASK_TOKEN_PATTERN[token])) {
                newValue = newValue + char;
            } else {
                idx = idx - 1;
            }
            valIdx = valIdx + 1;
        } else {
            newValue = newValue + token;
        }
    }

    el.value = newValue;

    event.preventDefault();

    const newEvent = new CustomEvent('input', {bubbles: true, detail: {repeat: true}});
    el.dispatchEvent(newEvent);
}

function formatCurrency(el, event) {
    if (event.detail && event.detail.repeat) {
        return true;
    }

	const originalValue = el.value;
    let value;
    if (originalValue) {
        value = (parseInt(originalValue.replace(',', ''))/100).toFixed(2).replace('.', ',');
    } else {
        value = '0,00';
    }

	el.value = value;

	event.preventDefault();

    const newEvent = new CustomEvent('input', {bubbles: true, detail: {repeat: true}});
    el.dispatchEvent(newEvent);
}

export const Mask = {
    mounted: (el, bindings) => {
        const mask = bindings.value.mask;
        const special = bindings.value.special;
        if (!mask && !special) {
            throw new Error('Mask not provided')
        }
        if (special) {
            if (special === '$'){
                el.addEventListener('input', (event) => {
                    formatCurrency(el, event);
                });
            }
        } else {
            el.addEventListener('input', (event) => {
                updateMask(mask, el, event);
            });
        }
    },
};